import React, { useState } from 'react'
import { Card, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { Close, Delete, Edit, MoreVert } from '@material-ui/icons'
import { Dropdown, Modal } from 'react-bootstrap'
import axios from 'axios';
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import { AccountCircle } from '@material-ui/icons';
import { Avatar } from '@mui/material';
import DeleteModal from '../../components/modals/DeleteModal';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const CompanyItem = ({ company, setOpen, getCompanies }) => {
    const dispatch = useDispatch()
    const [modalShow, setModalShow] = useState(false)

    const [loading, setLoading] = useState(false)




    const [deleteCompany, setDeleteCompany] = useState(false)
    const deleteOrganization = async () => {
        dispatch({ type: 'LOADING' })
        const data = new FormData();
        data.append('company_id', company.company_id);
        try {
            const res = await axios.post(ENDPOINT + "delete-company.php", data, SecurityHeaders);
            if (res.data.status === 'success') {
                setOpen({ open: true, message: 'Company deleted successfully', type: 'success' })
dispatch({ type:'DONE_LOADING'})
                setModalShow(false)
                setDeleteCompany(false)
                getCompanies()
            } else {
               dispatch({ payload: res.data.message,type:'ERROR'})
            }
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
           dispatch({ payload: error.message, type: 'ERROR'});
        } finally {
            setLoading(false);
        }
    };
    return (
        <>

            <>
                <DeleteModal show={deleteCompany} HandleClose={() => setDeleteCompany(false)} HandleDelete={deleteOrganization} />
            </>

            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center">

                <Card className="text-center shadow-sm position-relative" style={{ width: '18rem', borderRadius: '12px' }}>
                    <Dropdown className="options-dropdown position-absolute " style={{ top: 10, right: 10 }} >
                        <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                            <MoreVert className="text-dark" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item  >
                                <Link to={'/update-company/' + company.company_id} >
                                    <Edit /> Update</Link>
                            </Dropdown.Item>
                            <Dropdown.Item className='text-danger' onClick={() => setDeleteCompany(true)}   >
                                <Delete /> Delete
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="bg-primary rounded-top p-5">


                    </div>



                    <Card.Img
                        variant="top"
                        src={company.company_logo} // Ensure DB has image_url column
                        alt={company.company_name}
                        className="rounded-circle mx-auto d-block"
                        style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '-50px' }}
                    />

                    <Card.Body>
                        <h5>{company.company_name}</h5>
                        <p className="text">{company.company_description}</p>
                        <Button variant="outline-dark" className="rounded-pill">Show all</Button>
                    </Card.Body>

                </Card>
            </Col>

        </>
    )
}

export default CompanyItem
